"use client";

import { useEffect, useLayoutEffect } from 'react';
import { canUseDOM } from 'utils/can-use-dom';

/**
 * UseLayoutEffect logs a nasty warning with SSR. This is an established
 * "hack" to use `useEffect` in SSR instead.
 * Details here: https://medium.com/@alexandereardon/uselayouteffect-and-ssr-192986cdcf7a
 */

export const useIsomorphicLayoutEffect = canUseDOM()
  ? useLayoutEffect
  : useEffect;
